import React from 'react';
import { connect } from 'react-redux';
import { routes, TYPES } from 'constants/config';
import { Icon } from 'ui';
import RemoteAutoComplete from 'components/shared/RemoteAutoComplete';
import * as actions from 'actions/inPersonTraining/attendances';

const Suggestion = ({ name, type }) => (
  <span className="fz-20">
    {type === TYPES.GROUP && <Icon name="group" className="mr-8" />}
    {name}
  </span>
);

function filterSuggestions(attendances) {
  const selectedUserIds = attendances.map(({ user }) => user.id);
  return rawSuggestions =>
    rawSuggestions.filter(
      ({ type, id }) => !(type === TYPES.USER && selectedUserIds.includes(id)),
    );
}

const SearchInput = ({ attendances, createAttendance }) => (
  <RemoteAutoComplete
    url={routes.IN_PERSON_TRAINING.PEOPLE}
    mapResponseToSuggestions={response => response.data}
    onSuggestionSelected={createAttendance}
    filterSuggestions={filterSuggestions(attendances)}
    getSuggestionValue={suggestion => suggestion.name}
    renderSuggestion={Suggestion}
    placeholder={t('in_person_training.session.add_people')}
    className="NewInput NewInput--white NewInput--tall NewInput--fw fz-20"
  />
);

const mapStateToProps = state => ({
  attendances: state.attendances,
});

const mapDispatchToProps = {
  createAttendance: actions.createAttendance,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchInput);
